import { addWishlistItemTemplateURL } from '../../../configuration/Configuration.js';
import rejectNonOkResponse from '../rejectNonOkResponse.js';
export default (wishlistPublicId, prid, catalog) =>
  rejectNonOkResponse(
    fetch(addWishlistItemTemplateURL({ wishlistPublicId, prid, catalog }), {
      method: 'PUT',
      credentials: 'include',
    })
  ).then(() => true);
